import App from "byzantine/src/App";
import { useLocalization } from "@fluent/react";
import { InstitutionFeatures } from "byzantine/src/types";
import { translateOAuthApplication } from "byzantine/src/l10n/SettingLocalizers";

import cc from "classcat";
import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import AppAuthorize from "../../AppAuthorize";
import useIsServicesEnabled from "../ServicesCard.hooks";
import BorderCard from "../../BorderCard";

import styles from "./BorderedServicesCard.module.scss";
import useAoiobLink from "../hooks/useAoiobLink";

const AoiobItem = () => {
  const { l10n } = useLocalization();
  const onClick = useAoiobLink();

  return (
    <button
      data-classname="AppAuthorize services-button"
      className={cc(["button--reset", styles["service-box"]])}
      onClick={onClick}
      type="button"
    >
      <div className={styles["service-box-item"]}>
        <div className={styles["service-box-icon"]}>
          <span className="narmi-icon-plus-square" />
        </div>
        <div className="dashboard-item-subsection dashboard-item-text-section">
          <div className="dashboard-item-name">
            {l10n.getString(
              "services-item-open-an-account",
              {},
              "Open an account"
            )}
          </div>
          <div className="dashboard-item-description">
            {l10n.getString(
              "services-item-open-an-account-description",
              {},
              "Open an account with us!"
            )}
          </div>
        </div>
        <span
          className={cc([
            styles["service-box-chevron"],
            "narmi-icon-chevron-right"
          ])}
        />
      </div>
    </button>
  );
};

interface ServiceItemProps {
  service: App;
}
const ServiceItem = ({ service }: ServiceItemProps) => {
  const { l10n } = useLocalization();

  const translatedApp = translateOAuthApplication(
    {
      uuid: service.id,
      name: service.name,
      description: service.description
    },
    l10n
  );

  return (
    <AppAuthorize
      app={service}
      className={styles["service-box"]}
      dataClassnames="services-button"
    >
      <div className={styles["service-box-item"]}>
        <div className={styles["service-box-icon"]}>
          <span className={service.getNdsIconClassname()}></span>
        </div>
        <div className="dashboard-item-subsection dashboard-item-text-section">
          <div className="dashboard-item-name">{translatedApp.name}</div>
          <div className="dashboard-item-description">
            {translatedApp.description}
          </div>
        </div>
        <span
          className={cc([
            styles["service-box-chevron"],
            "narmi-icon-chevron-right"
          ])}
        />
      </div>
    </AppAuthorize>
  );
};

interface ServicesCardProps {
  services: App[];
}

const BorderedServicesCard = ({ services }: ServicesCardProps) => {
  const { l10n } = useLocalization();
  const { aoiob } = useUserFeatures() as InstitutionFeatures;
  const isVisible = useIsServicesEnabled(services);
  if (!isVisible) return null;
  return (
    <BorderCard title={l10n.getString("service-card-title")}>
      <div className={styles.services}>
        {services.map((service) => (
          <ServiceItem key={service.id} service={service} />
        ))}
        {aoiob && <AoiobItem />}
      </div>
    </BorderCard>
  );
};

export default BorderedServicesCard;
